export default () => ({
  policies: [],
  policiesMeta: {},
  files: [],
  policy: {},
  claims: [],
  claimsMeta: {},
  claimsHistoriesClaim: {},
  claim: {},
  partners: [],
  products: [],
  productCategories: [],
  uploadProgress: 0,
});
